import React from 'react';
import { MaterialCategory } from '@/types';

interface MaterialGridProps {
  onSelectMaterial: (category: MaterialCategory) => void;
}

const MaterialGrid: React.FC<MaterialGridProps> = ({ onSelectMaterial }) => {
  // Metal fabrication categories with icons
  const categories: MaterialCategory[] = [
    { id: 'header', name: 'Header', description: 'Top horizontal frame component', icon: '/icons/Header.png' },
    { id: 'sill', name: 'Sill', description: 'Bottom horizontal frame component', icon: '/icons/Sill.png' },
    { id: 'intermediate', name: 'Intermediate', description: 'Horizontal divider component', icon: '/icons/Intermediate.png' },
    { id: 'jamb', name: 'Jamb', description: 'Vertical frame component', icon: '/icons/Jamb.png' },
    { id: 'filler', name: 'Filler', description: 'Gap filling component', icon: '/icons/Filler.png' },
    { id: 'glass_stop', name: 'Glass Stop', description: 'Glass retention component', icon: '/icons/Glass_Stop.png' },
    { id: 'pan', name: 'Pan', description: 'Bottom support component', icon: '/icons/Pan.png' },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
      {categories.map((category) => (
        <div
          key={category.id}
          className="border rounded-lg p-4 shadow-sm hover:shadow-md transition-all bg-[#1e293b] border-[#4b5563] cursor-pointer hover:bg-[#243447] relative group"
          onClick={() => onSelectMaterial(category)}
        >
          <div className="flex flex-col items-center justify-center text-center">
            <div className="w-16 h-16 flex items-center justify-center mb-4 bg-white rounded-md p-2 shadow-sm">
              {category.icon ? (
                <img
                  src={category.icon}
                  alt={category.name}
                  className="w-full h-full object-contain"
                />
              ) : (
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center">
                  <span className="text-2xl font-bold text-primary">{category.name.charAt(0)}</span>
                </div>
              )}
            </div>
            <h3 className="text-2xl font-bold text-white">{category.name}</h3>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MaterialGrid;
